import React from 'react';
import { motion } from 'framer-motion';
import { Target } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import ig1 from "../../assets/osint/pentestHero.png";

const PentestHero = () => {
  const navigate = useNavigate();

  const colors = {
    primaryBlue: '#1e3a5f',
    accentBlue: '#3b82f6',
    textMain: '#0f172a',
    textSecondary: '#64748b',
    badgeBg: '#e0f2fe'
  };

  return (
    <div className="w-full flex flex-col font-inter">
      {/* MODIFICATION ICI : 
        - pt-[120px] sur mobile pour "pousser" le contenu sous la navbar.
        - lg:pt-16 sur desktop car la navbar est souvent moins gênante.
      */}
      <section className="w-full bg-[#f8fafc] pt-[120px] pb-12 lg:pt-16 lg:pb-12 flex justify-center overflow-hidden">
        <div className="max-w-[1100px] w-full px-6 flex flex-col lg:flex-row items-center gap-10 lg:gap-12">
          
          {/* GAUCHE: Texte */}
          <div className="flex-1 text-left z-10">
            {/* Ce badge ne sera plus caché par la navbar */}
            <div className="inline-block px-3 py-1 rounded-full mb-4" style={{ backgroundColor: colors.badgeBg }}>
              <span className="text-[9px] font-black uppercase tracking-wider" style={{ color: colors.accentBlue }}>
                Cybersecurity Expertise
              </span>
            </div>

            <h1 className="text-[36px] lg:text-[52px] font-[900] leading-[1.1] lg:leading-[1.05] tracking-tight mb-6" style={{ color: colors.textMain }}>
              Services <br />
              <span style={{ color: colors.primaryBlue }}>Pentest</span>
            </h1>

            <p className="text-[14px] lg:text-[15px] leading-relaxed mb-8 max-w-[440px] font-medium" style={{ color: colors.textSecondary }}>
              Sécurisez vos actifs numériques avec l'expertise Nodixs. Évaluez la résilience de votre infrastructure face aux cybermenaces avec des tests d'intrusion de pointe.
            </p>

            <div className="flex flex-wrap gap-4">
              <button 
                onClick={() => navigate('/rdv')}
                className="px-6 lg:px-7 py-3 lg:py-3.5 rounded-xl font-bold text-[13px] transition-all duration-300 shadow-[0_10px_20px_rgba(30,58,95,0.3)] hover:scale-105"
                style={{ backgroundColor: colors.primaryBlue, color: 'white' }}
              >
                Réserver un pentest
              </button>

            </div>
          </div>

          {/* DROITE: Image & Carte Flottante */}
          <div className="flex-1 relative mt-10 lg:mt-0 w-full max-w-[460px] lg:max-w-none">
            <div className="relative z-10">
              <img 
                src={ig1} 
                alt="Methodology" 
                className="w-full h-auto rounded-2xl mx-auto" 
                style={{ filter: 'drop-shadow(0 20px 40px rgba(0,0,0,0.08))' }}
              />
              
              <motion.div 
                animate={{ y: [0, -8, 0] }}
                transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
                className="absolute -bottom-4 -left-2 lg:-left-6 bg-white p-3 lg:p-3.5 rounded-2xl shadow-[0_15px_35px_rgba(0,0,0,0.1)] border border-slate-50 flex items-center gap-3 z-20"
              >
                <div className="bg-[#dcfce7] p-2 rounded-xl">
                  <Target size={18} className="text-[#16a34a]" />
                </div>
                <div>
                  <p className="text-[8px] lg:text-[9px] font-black text-slate-400 uppercase tracking-tighter">Statut</p>
                  <p className="text-[11px] lg:text-[13px] font-black" style={{ color: colors.primaryBlue }}>Veille Cyber Active</p>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PentestHero;
